import React, { Component } from 'react';
import GraphicList from '@/components/GraphicList';
import { getProjectImageText } from '@/api/personCenter/decorationManage';
import { Spin } from 'antd';
import { isMobile } from '&/utils/common';
import CarouselDig from '@/components/Dialogs/CarouselDig';
import { CAROUSEL_SETTINGS } from '&/constants/index';
import './index.scss';

export default class GraphicSolution extends Component {
    constructor(props) {
        super(props);
        this.state = {
            graphic: [],
            loading: false,
            previewVisible: false,
            selectedConstructionIndex: '0',
            selectNum: -1,
        };
    }

    componentDidMount() {
        this.setState({ loading: true });
        getProjectImageText({ projectVId: this.props.projectId, div: 2 })
            .then(({ data, code, msg }) => {
                if (code === 0) {
                    const list = data.map(v => {
                        v.group = v.group.map(item => {
                            item.img = item.path;
                            return item;
                        });
                        return v;
                    });
                    this.setState({ loading: false, graphic: list });
                } else {
                    this.setState({ loading: false });
                    throw msg;
                }
            })
            .catch(err => {
                this.setState({ loading: false });
                throw err;
            });
    }

    handleMobileImageClick = (e, index, obj) => {
        this.setState({
            selectedConstructionIndex: obj.index,
            selectNum: index,
            previewVisible: true,
        });
    };

    handleClose = () => {
        this.setState({
            previewVisible: false,
            selectNum: -1,
        });
    };

    render() {
        let { graphic, selectedConstructionIndex } = this.state;
        if (!graphic.length) {
            return null;
        }
        graphic = graphic.filter(v => v.group.length > 0);
        let pics = graphic[selectedConstructionIndex]?.group || [];
        const settings = {
            ...CAROUSEL_SETTINGS,
            prevArrow: null,
            nextArrow: null,
            hideNav: true,
            focusOnSelect: true,
        };
        return (
            <Spin spinning={this.state.loading}>
                <div className="graphic-solution">
                    {graphic.map(({ name, group }, index) => {
                        group = group.map(v => ({ ...v, index }));
                        return (
                            <div key={index}>
                                <label className="item-label">{name}</label>
                                <div className="item-wrapper">
                                    <GraphicList
                                        pics={group}
                                        handleImageClick={
                                            this.handleMobileImageClick
                                        }></GraphicList>
                                </div>
                                <label className="item-label-mobile">
                                    {name}
                                </label>
                            </div>
                        );
                    })}
                    {isMobile()
                        ? pics && (
                              <CarouselDig
                                  gap={90}
                                  selectNum={this.state.selectNum}
                                  visible={this.state.previewVisible}
                                  handleClose={this.handleClose}
                                  carouselSeting={settings}
                                  btnList={this.state.btnList}
                                  pics={pics}
                              />
                          )
                        : null}
                </div>
            </Spin>
        );
    }
}
